import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy } from '@angular/core';
import { BroadcasterService } from '@core/services/broadcaster.service';
import { DOCUMENT } from '@angular/common';
import { ThemeService } from '@core/services/theme.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionTimeoutService } from '@core/services/session-timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
  $destroy: Subject<void> = new Subject();

  constructor(
    private _broadcatser: BroadcasterService,
    @Inject(DOCUMENT) private document: Document,
    private themeService: ThemeService,
    private sessionTimeoutService: SessionTimeoutService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.themeService.initializeThemeDocument(document);

    if (!this.themeService.currentTheme) {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        // dark mode
        console.log('System Is in Dark mode');
        this.themeService.switchTheme('dark-theme');
      } else {
        this.themeService.switchTheme('light-theme');
      }
    }

    // app component broadasting
    this._broadcatser.broadcast('mykey', 'myvalue');
    //set dummy token just to enable auth guard for after-login module
    // localStorage.setItem('token', 'dummy');
    //localStorage.clear();
    /**
     * do this in other page, for e.g I'm doing here only
     * use this service with takeUntil from rxJS and local Subject to prevent memory leaks like shown
     */
    this._broadcatser
      .listen('mykey')
      .pipe(takeUntil(this.$destroy))
      .subscribe({
        next: (data) => console.log(data), // your broadcasted value
      });

    // start global session timeout watcher
    this.sessionTimeoutService.startWatching();
  }
  isInternal : boolean = false;
  ngOnInit(): void {
    this.router.events.subscribe(() => {
      const token = this.route.snapshot.queryParamMap.get('auth_token');
      const plantCodes = this.route.snapshot.queryParamMap.get('plant_code');
      if (token) {
        localStorage.setItem('auth_token', token);
      }

      if(plantCodes){
        this.isInternal = true;
        localStorage.setItem('plantCodes', plantCodes);
      }
    });
  }

  ngOnDestroy() {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
